<template>
  <div class="a_chat project_detail">
    <mt-header :title="detailObj.pro_info.proname_en">
      <span slot="left" @click="()=>this.$router.back()">
        <i class="iconfont icon-left"></i>
        Return
      </span>
    </mt-header>
    <div class="dialogue_content">
      <ul class="ul_list_bottom" ref="box">
        <li v-for="item in detailObj.list" :key="item.id">
          <div class="ul_item" v-if="item.sendid*1!=user.id">
            <div class="ul_item_left">
              <img :src="item.send_img" alt="" />
            </div>
            <div class="ul_item_right">
              <p class="consulting_p">
                <span class="consulting_title">{{item.name?item.name:item.nickname}}</span>
                <span class="consulting_time">{{item.ctime}}</span>
              </p>
              <p class="consulting_p">
                <span class="sanjiao"></span>
                {{item.content}}
              </p>
            </div>
          </div>
          <div class="ul_item ul_item_me" v-else>
            <div class="ul_item_right_me">
              <p class="consulting_p">
                <span class="consulting_title">{{item.name?item.name:item.nickname}}</span>
                <span class="consulting_time">{{item.ctime}}</span>
              </p>
              <p class="consulting_p">
                <span class="sanjiao sanjiao_right"></span>
                {{item.content}}
              </p>
            </div>
            <div class="ul_item_left ul_item_left_me">
              <img :src="item.send_img" alt="" />
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="dialogue_input_bg"> 
      <el-input class="textarea" type="textarea" placeholder="Input Message" v-model="textarea" maxlength="200" show-word-limit />
      <el-button class="btn" type="primary" size="small" @click.stop="msgSend">Send</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { Header } from 'mint-ui';
import { reqMynoteOne ,reqMynoteAdd } from "../../../../api";
export default {
  components:{
    'mt-header':Header
  },
  data(){
    return{
      detailObj:{
        corp_info:{},
        pro_info:{},
        list:[],
      },
      textarea:'',
      information:{}
    }
  },
  mounted(){
    // console.log(this.$route.params);
    this.information = this.$route.params
    this.init(this.$route.params)
  },
  methods:{
    async init(item){
      const response = await reqMynoteOne(item.sendid,item.putid,item.pid)
      if (response.code==3) {//数据正常
        this.detailObj = {
          corp_info:response.corp_info,
          pro_info:response.pro_info,
          list:response.reslist.reverse(),
        }
        // this.centerDialogVisible=true
        setTimeout(()=>{
          this.$refs.box.scrollTop = this.$refs.box.scrollHeight
        })
      }
    },
    async msgSend(){//发送
     let putid = this.user.id==this.detailObj.list[0].putid?this.detailObj.list[0].sendid:this.detailObj.list[0].putid
      const response = await reqMynoteAdd(putid,this.detailObj.list[0].pid,this.textarea)
      if (response.code==3) {
        this.textarea=''
        this.init(this.information)
      }else if (response.code==2) {
        // console.log(response.msg);
      }else if (response.code==1) {
        // console.log(response.msg);
      }else if (response.code==0) {
        // console.log(response.msg);
      }
    },
  },
  computed:{
    ...mapState({
      user:state=>state.user.user,
    })
  },
}
</script>

<style scoped>
  .a_chat{
    height: 100%;
    background-color: #f4f4f4;
  }
  .dialogue_content{
    height: calc(100% - 102px);
  }
  .ul_list_bottom{
    height: 100%;
    overflow: auto;
  }
  .ul_item{
    width: 100%;
    padding: 10px;
    display: flex;
    margin-top: 6px;
  }
  .ul_item_left{
    width: 50px;
    margin-right: 10px;
  }
  .ul_item_left>img,
  .ul_item_left_me>img{
    height: auto;
  }
  .ul_item_right{
    width: calc(100% - 60px);
  }
  .consulting_p+.consulting_p{
    margin-top: 4px;
    position: relative;
    display: inline-block;
    padding: 8px 10px;
    background-color: white;
    border-radius: 4px;
    width: auto;
    box-shadow: 1px 1px 4px rgb(185, 185, 185);
    max-width: 200px;
    text-align: left;
    line-height: 18px;
    word-wrap: break-word;
    table-layout: fixed;
    word-break: break-all;
  }
  .consulting_time{
    font-size: 12px;
  }
  .consulting_title{
    font-size: 14px;
    font-weight: 600;
    margin-right: 6px;
  }

  .ul_item_me{
    justify-content: flex-end;
  }
  .ul_item_me .ul_item_right_me{
    width: auto;
    text-align: end;
  }
  .ul_item_left_me{
    margin-left: 10px;
    margin-right: 0;
  }

  .sanjiao{
    position: absolute;
    left: -16px;
    top: 8px;
    width: 0;
    height: 0;
    border: 8px solid;
    border-color: transparent white transparent transparent ;
    
  }
  .sanjiao_right{
    left: auto;
    right: -16px;
    border-color: transparent transparent transparent white;
  }

/* 聊天框 */
  
  .dialogue_input_bg{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: #e7e7e7;
    padding: 6px;
  }
  .textarea{
    width: 82%;
    height: 40px;
    line-height: 1;
    margin: auto;
    border-radius: 4px;
    vertical-align: middle;
  }
  .textarea>>>.el-textarea__inner{
    height: 100%;
  }
  .btn{
    width: calc(18% - 6px);
    margin-left: 6px;
    vertical-align: middle;
  }

</style>